import { useState, useEffect } from "react";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";

const CandidatureTrainer = () => {
  const [candidature, setCandidature] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const perPage = 10;
  const totalRows = candidature.length;
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "TRAINER") {
      alert("Accedi come docente per visualizzare le candidature!");

      navigate("/login");
      localStorage.clear();
    } else {
      fetchCandidature();
    }
  }, [navigate]);

  const fetchCandidature = async () => {
    try {
      setLoading(true);
      const response = await api.get("/candidature/me");
      if (response.status === 200) {
        setCandidature(response.data);
      } else {
        toast.error("Errore durante il recupero delle candidature!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const isoDatePart = dateString.slice(0, 10);
    const [year, month, day] = isoDatePart.split("-");
    if (!year || !month || !day) return "";

    return `${day}.${month}.${year}`;
  };

  const formattedCandidature = candidature.map((c) => ({
    ...c,
    dataCandidaturaFormatted: formatDate(c.dataCandidatura),
    dataEsitoFormatted: formatDate(c.dataEsito),
  }));

  const columns = [
    {
      field: "dataCandidaturaFormatted",
      header: "Data Candidatura",
      enableColumnFilterModes: true,
    },
    {
      field: "esito",
      header: "Esito",
    },
    {
      field: "descrizioneEsito",
      header: "Descrizione Esito",
    },
    {
      field: "dataEsitoFormatted",
      header: "Data Esito",
      enableColumnFilterModes: true,
    },

    {
      field: "titoloModulo",
      header: "Titolo Modulo",
    },

    {
      header: "Azioni",
      Cell: ({ row }) => {
        const { id, esito } = row.original;
        const inLavorazione = esito === "In Lavorazione";

        return (
          inLavorazione && (
            <button
              className="apply-btn"
              onClick={(e) => {
                e.stopPropagation();
                withdrawCandidature(id);
              }}
            >
              Ritirare la candidatura
            </button>
          )
        );
      },
    },
  ];

  const withdrawCandidature = async (id) => {
    try {
      setLoading(true);
      const response = await api.post(`/candidature/withdraw/${id}`);
      if (response.status === 200) {
        toast.success("Candidatura ritirata con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        fetchCandidature();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Candidature</div>
      </div>

      <div className="page-content trainers">
        <Table
          columns={columns}
          data={formattedCandidature}
          onPageChange={handlePageChange}
          totalRows={totalRows}
          perPage={perPage}
          currentPage={page}
          paginationComponentOptions={{
            rowsPerPageText: "",
          }}
        />
      </div>
    </div>
  );
};

export default CandidatureTrainer;
